export default class RayTracingSelector {
  static getRayTracingJobs = state => state.rayTracing.entities.rayTracingJobs;
  static getSelectedJobId = state => state.rayTracing.ui.selectedJobId;
  static getTempSweptVariables = state =>
    state.rayTracing.ui.tempSweptVariables;
}
